import styled from 'styled-components';
import SearchSidebar from 'components/common/search/sidebar';
import { StyleConstant } from 'util/getStyleConstant';

export const StyledCourseSearchSidebar = styled(SearchSidebar)`
  background: transparent;
  @media screen and (min-width: ${StyleConstant.BREAKPOINT_HANDHELD}) {
    max-width: 360px;
    min-width: 360px;
    border-right: none;
  }
`;
